module.exports = __webpack_public_path__ + "static/media/virusRed.089cd3aa.png";